<template>
  <div class="timeline-item-content">
    <!-- <pre>{{ activity_content }}</pre> -->
    <div class="timeline-item-custom-content">
      <slot></slot>
    </div>
    <div
      v-if="
        activity_content.content_group &&
        activity_content.content_group.length > 0
      "
      class="timeline-item-images grid grid-cols-3"
    >
      <div
        class="h-max"
        v-for="(content, index) in activity_content.content_group"
        :key="`image-${index}`"
      >
        <div
          class="border border-[#F5F5F5] rounded-lg p-3 h-full"
          v-if="content.images && content.images.length > 0"
        >
          <div
            class="flex items-center gap-2 mb-2"
            :class="{
              'justify-between': !isNullOrEmpty(content.nickName),
              'justify-end': isNullOrEmpty(content.nickName),
            }"
          >
            <div class="flex flex-col" v-if="!isNullOrEmpty(content.nickName)">
              <span class="text-[11px] text-[#5F5F5F] font-[400] mb-0"
                >Nick Name:</span
              >
              <span
                class="font-semibold text-[14px] capitalize tracking-[-1px]"
                >{{ content.nickName }}</span
              >
            </div>
            <!-- <button class="bg-primary text-white rounded-md text-center p-1">
              <QueueListIcon class="size-6" />
            </button> -->
          </div>
          <div class="grid grid-cols-2">
            <template v-for="(image, index) in content.images" :key="index">
              <template v-if="!image.url || image.url !== 'null'">
                <template
                  v-if="['jpg', 'jpeg', 'png', 'bmp'].includes(image.ext)"
                >
                  <img
                    :src="
                      image && image.url
                        ? `${storage_url}/${image?.url}`
                        : imgPlaceholder
                    "
                    :alt="image?.alt || ''"
                    class="object-contain h-full"
                    @click="onImageClick(image?.url ?? null)"
                  />
                </template>
                <DocumentTextIcon v-else class="w-full text-gray-200" />
              </template>
            </template>
          </div>
        </div>

        <div v-if="content.addons.length > 0" class="flex gap-2 px-3">
          <div class="flex flex-wrap gap-1">
            <span
              v-for="addon in content.addons"
              :key="`addon-${addon.addon_id}`"
              class="px-2 py-1 bg-[#DEEDFF] rounded-lg text-[12px] font-normal"
            >
              {{ addon.title }}
            </span>
          </div>
        </div>

        <div
          v-if="!isNullOrEmpty(content.skipReason)"
          class="flex gap-2 mb-2 text-sm"
        >
          <span class="font-semibold">Skip Reason:</span>
          <span class="px-2 py-1 text-xs">
            {{ content.skipReason }}
          </span>
        </div>

        <div
          v-if="!isNullOrEmpty(content.message)"
          class="flex gap-2 mb-2 text-sm"
        >
          <span class="font-semibold">Feedback:</span>
          <span class="text-gray-600">{{ content.message }}</span>
        </div>

        <div
          v-if="
            content.status === FACTORYREVIEW &&
            !isNullOrEmpty(content.reorder_message)
          "
          class="text-sm text-gray-600"
        >
          {{ content.reorder_message }}
        </div>
      </div>
    </div>
    <div class="timeline-item-custom-content">
      <slot name="comments"> </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import imgPlaceholder from "@/assets/img/placeholder.png";
import { CustimooOrderFlowStatuses, isNullOrEmpty } from "@/composables";
import { Addon } from "@/models";
import { DocumentTextIcon, QueueListIcon } from "@heroicons/vue/24/solid";
const { FACTORYREVIEW } = CustimooOrderFlowStatuses;
interface Image {
  url: string;
  alt?: string;
  ext?: string;
}
interface Content {
  images: Image[];
  nickName: string;
  addons: Addon[];
  skipReason: string;
  status: string;
  message: string;
  reorder_message: string;
}
interface ActivityContent {
  content_group?: Content[];
  activity_status?: string;
}
interface Props {
  activity_content?: ActivityContent;
}

withDefaults(defineProps<Props>(), {
  activity_content: () => ({}),
});

const storage_url = import.meta.env.VITE_APP_FILE_URL;
const emit = defineEmits(["showPreview"]);

const onImageClick = (image_url) => {
  if (image_url) {
    emit("showPreview", image_url);
  }
  return;
};
</script>

<style scoped lang="scss">
.timeline-item-content {
  .timeline-item-description {
    margin-bottom: 1rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #4b5563; /* gray-600 */
  }

  .timeline-item-images {
    gap: 0.5rem;
    margin-bottom: 1rem;

    .timeline-item-image {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .timeline-item-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;

    .timeline-item-action-button {
      padding: 0.5rem 1rem;
      background-color: #f3f4f6; /* gray-100 */
      border: 1px solid #e5e7eb; /* gray-200 */
      border-radius: 0.25rem;
      font-size: 0.875rem;
      color: #374151; /* gray-700 */
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: #e5e7eb; /* gray-200 */
      }
    }
  }
}
.timeline-item-custom-content {
  height: max-content;
}
</style>
